import React, { PureComponent, Fragment } from 'react'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator'
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit'
import { Loader } from 'modules/shared'
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import { DateTime } from 'luxon'
import { emissToDate, toMoney, getHTTPClient, showNotification } from 'helpers'

const { SearchBar } = Search
const titles = {
    vendas_sem_numero: 'Vendas s/número',
    venda_detalhada: 'Venda detalhada (Venda)',
    venda_detalhada_caixa: 'Venda detalhada (Caixa)',
    cupons_emitidos: 'Cupons emitidos AS',
    cupons_emitidos_sefaz: 'Cupons emitidos SEFAZ',
    cupons_cancelados: 'Cupons cancelados',
    notas55: 'Notas 55',
    notas_rejeitadas: 'Notas rejeitadas',
    somente_sefaz: 'Somente SEFAZ',
    cancelados_vendas: 'Cancelados na Venda Det.'
}

const ExportCSV = (props) => {
    const handleClick = () => props.onExport()
    return (
        <button className="btn btn-info btn-sm" disabled={props.disabled} onClick={handleClick}>Exportar CSV</button>
    )
}

const emissFormat = cell => emissToDate(cell)
const moneyFormat = cell => toMoney(cell)

class SatDetail extends PureComponent {

    constructor(props) {
        super(props)
        this.state = {
            dados: [],
            total: 0
        }
        this.closeBtn = React.createRef()
        this.table = React.createRef()
        this.onClose = this.onClose.bind(this)
    }

    getTitle() {
        return `${this.props.content.nomeEmpresa} - ${titles[this.props.content.type]} (${DateTime.fromJSDate(this.props.dateIni).toFormat('dd/MM/yyyy')} - ${DateTime.fromJSDate(this.props.dateEnd).toFormat('dd/MM/yyyy')})`
    }

    mount() {
        let columns = []
        switch (this.props.content.type) {
            case 'vendas_sem_numero':
                columns = [
                    { dataField: 'id', text: 'ID', sort: true, hidden: true, csvExport: false },
                    { dataField: 'emissao', text: 'Emissão', sort: true, formatter: emissFormat, csvFormatter: emissFormat },
                    { dataField: 'valor', text: 'Valor', sort: true, formatter: moneyFormat, csvType: 'Number' }
                ]
                return this.prepareTable(`/sat/vendas-sem-numero/${this.props.content.emp}`, columns)
            case 'venda_detalhada':
                columns = [
                    { dataField: 'id', text: 'ID', sort: true, hidden: true, csvExport: false },
                    { dataField: 'emissao', text: 'Emissão', sort: true, formatter: emissFormat, csvFormatter: emissFormat },
                    { dataField: 'cupom', text: 'Cupom', sort: true },
                    { dataField: 'valor', text: 'Valor', sort: true, formatter: moneyFormat, csvType: 'Number' }
                ]
                return this.prepareTable(`/sat/venda-detalhada/${this.props.content.emp}`, columns)
            case 'venda_detalhada_caixa':
                columns = [
                    { dataField: 'id', text: 'ID', sort: true, hidden: true, csvExport: false },
                    { dataField: 'emissao', text: 'Emissão', sort: true, formatter: emissFormat, csvFormatter: emissFormat },
                    { dataField: 'cupom', text: 'Cupom', sort: true },
                    { dataField: 'valor', text: 'Valor', sort: true, formatter: moneyFormat, csvType: 'Number' }
                ]
                return this.prepareTable(`/sat/venda-detalhada-caixa/${this.props.content.emp}`, columns)
            case 'cupons_emitidos':
                columns = [
                    { dataField: 'id', text: 'ID', sort: true, hidden: true, csvExport: false },
                    { dataField: 'emissao', text: 'Emissão', sort: true, formatter: emissFormat, csvFormatter: emissFormat },
                    { dataField: 'cupom', text: 'Cupom', sort: true },
                    { dataField: 'modelo', text: 'Modelo', sort: false },
                    { dataField: 'valor', text: 'Valor', sort: true, formatter: moneyFormat, csvType: 'Number' }
                ]
                return this.prepareTable(`/sat/cupons-emitidos/${this.props.content.emp}`, columns)
            case 'cupons_emitidos_sefaz':
                columns = [
                    { dataField: 'chave_acesso', text: 'Chave', sort: true, csvType: "String" },
                    { dataField: 'emiss_id', text: 'Emissão', sort: true, formatter: emissFormat, csvFormatter: emissFormat },
                    { dataField: 'cupom', text: 'Cupom', sort: true },
                    { dataField: 'valor', text: 'Valor', sort: true, formatter: moneyFormat, csvType: 'Number' },
                    { dataField: 'recibo', text: 'Recibo', sort: true }
                ]
                return this.prepareTable(`/sat/cupons-emitidos-sefaz/${this.props.content.emp}`, columns, 'chave_acesso', [{ dataField: 'emiss_id', order: 'asc' }])
            case 'cupons_cancelados':
                columns = [
                    { dataField: 'chave_acesso', text: 'Chave', sort: true, csvType: "String" },
                    { dataField: 'chave_acesso_cancelamento', text: 'Cancelamento', sort: true, csvType: "String" },
                    { dataField: 'emissao', text: 'Emissão', sort: true, formatter: emissFormat, csvFormatter: emissFormat },
                    { dataField: 'cupom', text: 'Cupom', sort: true },
                    { dataField: 'valor', text: 'Valor', sort: true, formatter: moneyFormat, csvType: 'Number' },
                ]
                return this.prepareTable(`/sat/cupons-cancelados/${this.props.content.emp}`, columns, 'chave_acesso', [{ dataField: 'emiss_id', order: 'asc' }])
            case 'notas55':
                columns = [
                    { dataField: 'id', text: 'ID', sort: true, hidden: true, csvExport: false },
                    { dataField: 'emissao', text: 'Emissão', sort: true, formatter: emissFormat, csvFormatter: emissFormat },
                    { dataField: 'numero_nota', text: 'Nota', sort: true },
                    { dataField: 'cfop', text: 'CFOP', sort: false },
                    { dataField: 'valor', text: 'Valor', sort: true, formatter: moneyFormat, csvType: 'Number' },
                    { dataField: 'situacao', text: 'Situação', sort: true }
                ]
                return this.prepareTable(`/sat/notas55/${this.props.content.emp}`, columns)
            case 'notas_rejeitadas':
                columns = [
                    { dataField: 'venda_id', text: 'ID', sort: true, hidden: true, csvExport: false },
                    { dataField: 'emissao', text: 'Emissão', sort: true, formatter: emissFormat, csvFormatter: emissFormat },
                    { dataField: 'cupom', text: 'Cupom', sort: true },
                    { dataField: 'valor', text: 'Valor', sort: true, formatter: moneyFormat, csvType: 'Number' }
                ]
                return this.prepareTable(`/sat/notas-rejeitadas/${this.props.content.emp}`, columns, 'venda_id')
            case 'somente_sefaz':
                columns = [
                    { dataField: 'chave_acesso', text: 'Chave', sort: true, csvType: "String" },
                    { dataField: 'emiss_id', text: 'Emissão', sort: true, formatter: emissFormat, csvFormatter: emissFormat },
                    { dataField: 'cupom', text: 'Cupom', sort: true },
                    { dataField: 'recibo', text: 'Recibo', sort: true },
                    { dataField: 'valor', text: 'Valor', sort: true, formatter: moneyFormat, csvType: 'Number' },
                ]
                return this.prepareTable(`/sat/somente-sefaz/${this.props.content.emp}`, columns, 'chave_acesso')
            case 'cancelados_vendas':
                columns = [
                    { dataField: 'chave_acesso', text: 'Chave', sort: true, csvType: "String" },
                    { dataField: 'emiss_id', text: 'Emissão', sort: true, formatter: emissFormat, csvFormatter: emissFormat },
                    { dataField: 'cupom', text: 'Cupom', sort: true },
                    { dataField: 'valor', text: 'Valor', sort: true, formatter: moneyFormat, csvType: 'Number' },
                ]
                return this.prepareTable(`/sat/cancelados-venda/${this.props.content.emp}`, columns, 'chave_acesso')
            default: return
        }
    }

    onClose() {
        this.setState({ dados: [], total: 0 })
    }

    prepareTable(url, columns, key = 'id', defaultSorted = [{ dataField: 'emissao', order: 'asc' }]) {

        if (this.state.dados.length === 0) {
            const client = getHTTPClient()
            client({
                method: 'POST',
                url,
                data: {
                    ini: this.props.dateIni,
                    end: this.props.dateEnd
                }
            }).then(response => {
                if (response.data.dados.length) {
                    setTimeout(() => {
                        this.setState({...response.data})
                    }, 500)
                } else {
                    showNotification('Não há dados para exibir.')
                    this.closeBtn.current.click()
                }
            })
                .catch(error => {
                    if (error.response)
                        showNotification(error.response.data.message, 'alert-danger')
                    else
                        showNotification('Algo deu errado :/', 'alert-danger')
                    this.closeBtn.current.click()
                })
        }

        return (
            <ToolkitProvider
                keyField={key}
                data={this.state.dados}
                columns={columns}
                search={{ searchFormatted: true }}
                exportCSV
            >
                {props => (
                    <Fragment>
                        <div className="row">
                            <div className="col-12 col-sm-5">
                                <SearchBar placeholder="Pesquisar..." className="form-control-sm" {...props.searchProps} />
                            </div>
                            <div className="col-12 col-sm-2">
                                <ExportCSV {...props.csvProps} disabled={props.baseProps.data.length ? false : true} />
                            </div>
                        </div>

                        <hr />
                        <BootstrapTable
                            {...props.baseProps}
                            bootstrap4
                            hover
                            classes="table-sm"
                            wrapperClasses="table-responsive"
                            defaultSorted={defaultSorted}
                            pagination={paginationFactory({ showTotal: true, paginationTotalRenderer: (from, to, size) => (<span className="pl-3">Exibindo linhas {from} a {to} de {size}</span>) })}
                            noDataIndication={() => <Loader noPage />}
                            ref={this.table}
                        />
                    </Fragment>
                )}

            </ToolkitProvider>
        )

    }

    render() {
        return (
            <Modal size="lg" className="modal-bigger" isOpen={this.props.shouldShow} toggle={this.props.toggleDetail} onClosed={this.onClose}>
                <ModalHeader toggle={this.props.toggleDetail}>{this.getTitle()}</ModalHeader>
                <ModalBody style={{ fontSize: '.85rem' }}>

                    <p className="mb-2">
                        <strong className="pr-2">Total:</strong>{toMoney(this.state.total)}
                    </p>

                    {this.mount()}

                </ModalBody>
                <ModalFooter>
                    <button ref={this.closeBtn} className="btn btn-secondary" onClick={this.props.toggleDetail}>Fechar</button>
                </ModalFooter>
            </Modal>
        )
    }

}

export default SatDetail